module.exports = __webpack_public_path__ + "img/tx1@3x.d9f2a7c8.svg";